import {
  MediaQueries,
  Spacing
} from 'UI'

export default theme => ({
  goBackIcon: {
    fontSize: 16,
    color: theme.primary[0],
    backgroundColor: theme.neutral[0],
    cursor: 'pointer',
    borderRadius: 8,
    padding: () => Spacing(4),
    margin: () => Spacing(10, 0, 6, 0)
  },
  card: {
    margin: () => Spacing(0, 0, 4, 0)
  },
  resultInfos: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 29px 0'
  },
  iconClass: {
    color: theme.secondary[0],
    fontSize: 16,
    lineHeight: 0,
    padding: '0 6px 0 0'
  },
  advertisementContainer: {
    marginBottom: 128
  },
  [`${MediaQueries.tablet}`]: {
    goBackIcon: {
      margin: () => Spacing(4, 0, 6, 0)
    },
    advertisementContainer: {
      marginBottom: 64
    }
  },
  [`${MediaQueries.mobile}`]: {
    goBackIcon: {
      margin: () => Spacing(4, 0, 6, 0)
    },
    advertisementContainer: {
      marginBottom: 64
    }
  }
})
